export const update = (state, payload) => ({
    ...state,
    ...payload,
});

export const clear = () => (null);
